import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from '../shared/Modal';
import { wrapEventHandler } from '../../utils/handlers';
import { activities } from '../../utils/activity_util';
import styles from './styles/styles.module.scss';

const MapSelectorModal = ({
  title,
  sections,
  taller,
  handleCardClick,
  handleClose,
  handleActivityFilterChange,
  selectedFilterActivity,
  ctaFooter,
  adminLayout
}) => {
  // Stateless component equivalents of componentDidMount/componentWillUnmount
  const handleKeyDown = e => {
    if (e.keyCode == 27) {
      // Esc
      handleClose();
    }
  };
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  const onSelectChange = e => {
    handleActivityFilterChange(e);
  };

  const renderHeader = (index, header) => {
    if (!header) {
      return <div className={`${styles.sectionBarOnly} ${index > 0 ? styles.showDividerBar : ''}`} />;
    }
    return <div className={`${styles.sectionHeader} ${index > 0 ? styles.showDividerBar : ''}`}>{header}</div>;
  };
  const renderDropdownSelect = () => {
    const options = activities.map(activity => {
      return <option value={activity.value}>{activity.label}</option>;
    });
    options.unshift(<option value="">All</option>);
    return (
      <select value={selectedFilterActivity} onChange={onSelectChange} className={styles.activitySelect}>
        {options}
      </select>
    );
  };

  const renderCards = cards =>
    cards.map(card => {
      const onClick = card.grayed ? null : wrapEventHandler(e => handleCardClick(card.key, e));
      const dropdown = ['recordingsAll', 'recordingsPop'].indexOf(card.key) > -1 ? renderDropdownSelect() : null;
      return (
        <div
          key={`key-${card.key}`}
          className={`${styles.card} ${card.selected ? styles.selected : ''} ${card.grayed ? styles.grayed : ''}`}
          onClick={onClick}
        >
          <div className={styles.cardTitle} data-test-id={card.title}>
            {card.title}
          </div>
          {dropdown}
          <img src={card.imgSrc} />
        </div>
      );
    });
  const children = sections.map((section, i) => {
    return (
      <div key={section.key}>
        {renderHeader(i, section.header)}
        <div className={styles.cardContainer}>{renderCards(section.cards)}</div>
      </div>
    );
  });
  const renderCTAFooter = () => {
    if (!ctaFooter) {
      return null;
    }
    return (
      <div className={styles.ctaFooter}>
        {ctaFooter.secondary && (
          <a onClick={ctaFooter.secondary.onClick} data-test-id={ctaFooter.secondary.label}>
            {ctaFooter.secondary.label}
          </a>
        )}
        <Button className={styles.button} onClick={ctaFooter.primary.onClick} data-test-id={ctaFooter.primary.label}>
          {ctaFooter.primary.label}
        </Button>
      </div>
    );
  };
  const adminStyles = () => {
    if (!adminLayout) {
      return null;
    }
    // Make popup wider for admins using Windows, otherwise scrollbar width causes line wrap
    const widenForScrollbars = window.navigator && window.navigator.userAgent.match(/Windows/);
    return `${styles.adminLayout} ${widenForScrollbars ? styles.widenForScrollbars : null}`;
  };
  return (
    <Modal handleBackgroundClick={handleClose} modalStyle={{ zIndex: 1003 }}>
      <div className={`${styles.mapSelectorContainer} ${taller ? styles.taller : null} ${ctaFooter ? styles.withCTAFooter : null} ${adminStyles()}`}>
        <div className="close" onClick={handleClose} />
        <div className={styles.title}>{title}</div>
        <div id="section-container" className={`reset-box-sizing ${styles.sectionContainer}`}>
          {children}
        </div>
        {renderCTAFooter()}
      </div>
    </Modal>
  );
};

export default MapSelectorModal;
